import { MenuItem, Select } from "@tm/components"
import { useVefilesSearch } from "../../hooks/useVefilesSearch"
import { useEffect, useMemo, useState } from "react"
import { useLocalization } from "@tm/localization"
import { getAllSubcategories } from "@bundles/vefiles/helpers"

export function CategoryFilter() {
    const {
        search: { tempSelectedCategory, handleSelectedCategory },
    } = useVefilesSearch()

    const { translateText } = useLocalization()

    const categories = useMemo(() => getAllSubcategories(translateText), [translateText])

    const [selectedCategory, setSelectedCategory] = useState(categories[0])

    useEffect(() => {
        if (!tempSelectedCategory) {
            setSelectedCategory(categories[0])
            return
        }

        setSelectedCategory(tempSelectedCategory)

    }, [tempSelectedCategory])

    function onCategorySelected(index: number) {
        handleSelectedCategory(categories[index])
    }

    return (
        <Select
            sx={{height:"34px"}}
            variant="outlined"
            value={selectedCategory.id}
            renderValue={(index) => categories[index as number].categoryName}
            onChange={(e) => onCategorySelected(e.target.value as number)}
        >
            {categories.map((category, index) => {
                return (
                    <MenuItem key={category.id} value={category.id}>
                        {categories[index as number].categoryName}
                    </MenuItem>
                )
            })}
        </Select>
    )
}
